import client from "./client";
import { SurveyStatusResult, StatusUserStrategy, UsersResult, SingleUserResult } from "@/interfaces";

export const getStatus = () => client.get<SurveyStatusResult>("status");
export const getUsers = () => client.get<UsersResult>("users");
export const getSingleUser = (id: number) => client.get<SingleUserResult>(`users/${id.toString()}`);
export const sendReminder = (id: number, data: { subject: string; message: string }) =>
  client.post<any>(`/users/reminder/${id.toString()}`, { ...data });
export const supportRequest = (data: { subject: string; message: string }) =>
  client.post<SurveyStatusResult>("supportRequest", { ...data });
export const getStatusUserStrategy = () => client.get<StatusUserStrategy>("status/user-strategy");
